addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('[data-link-onclick="popup"] a[title]').forEach((link)=>{
    // console.log(link);
  
    let wrapper = link.closest('[data-link-onclick="popup"]');
    if(wrapper.classList.contains('accordion__content')){
      link.classList.add('accordion__content_btn_link');
    }
    let wrapperRect = wrapper.getBoundingClientRect();
  
    let button = document.createElement('button');
    button.className = link.className;
    button.innerHTML = link.innerHTML;
    button.setAttribute('data-popup-text', link.getAttribute('title'));
    button.removeAttribute('title');
    
    link.parentNode.replaceChild(button, link);
    
    let popup = document.createElement('div');
    popup.classList.add('accordion__content_popup');
    popup.classList.add('link_content_popup');
    
    let popupContent = document.createElement('p');
    popupContent.innerHTML = wrapUrlsWithAnchorTag(button.getAttribute('data-popup-text'));
    
    button.append(popup);
    popup.append(popupContent);
  
    let linkRect = button.getBoundingClientRect();
    let popupRect = popup.getBoundingClientRect();
    
    let leftPosition = wrapperRect.left;

    if(wrapper.classList.contains('product-geo-text-block')){
      popup.style.left = `0px`;
    }else{
      popup.style.left = `${leftPosition - linkRect.left}px`;
    }
  
    let accordion_width = wrapper.offsetWidth;
    // console.log(accordion_width);
    popup.style.width = `${accordion_width}px`;
  
    button.addEventListener('mouseenter', showTooltip);
    button.addEventListener('mouseleave', hideTooltip);
    button.addEventListener('click', showTooltip);
    
    function showTooltip(event){
      popup.classList.add('active');
    }
    function hideTooltip(event){
      popup.classList.remove('active');
    }
  })
});
  
function wrapUrlsWithAnchorTag(paragraph) {
  
  let urlPattern = /https?:\/\/[^\s]+/g;
  
  let paragraphWithLinks = paragraph.replace(urlPattern, function(url) {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });
  
  return paragraphWithLinks;
}